import { SIGEIF_ORGANIZATION_ID } from '~/app/constants/sigeif-organization';

export function isSigeifOrganization(organizationId: string): boolean {
  return organizationId === SIGEIF_ORGANIZATION_ID;
}
